import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    dialogId: String,
  }

  DIALOG_OPEN_CLASS = 'components--modal__dialog--open'
  DIALOG_CONTROLLER = 'ui--modal--dialog'

  connect() {
    this.dialog = document.querySelector(`dialog#${this.dialogIdValue}`)

    if (this.dialog == null) {
      throw new Error('Missing dialog in modal controller!')
    }

    // NOTE: Originally this would just query for the dialog inside of the element
    // However, it is possible that this page is being visited via restore e.g. forwards/back
    // In that case the dialog has already been removed from the element and appended.
    // That's why we check here to see if the element contains the dialog.
    if (this.element.contains(this.dialog)) {
      this.element.removeChild(this.dialog)
      this.dialog.setAttribute('data-controller', this.DIALOG_CONTROLLER)
      document.body.append(this.dialog)
    }

    this.element.addEventListener('modal:open', this.handleOpen)
  }

  handleOpen = () => {
    this.dialog.hidden = false
    requestAnimationFrame(() => {
      this.dialog.classList.add(this.DIALOG_OPEN_CLASS)
      this.dialog.showModal()
    })
  }

  disconnect() {
    // restore initial state, with dialog contained within element
    // connect remains idempotent in case this does not run for whatever reason
    if (document.body.contains(this.dialog)) {
      document.body.removeChild(this.dialog)
      this.dialog.removeAttribute('data-controller')
      this.element.appendChild(this.dialog)
    }

    this.element.removeEventListener('modal:open', this.handleOpen)
  }
}
